export default "__VITE_ASSET__DPKPelCB__"